import { Globe, Lock } from 'lucide-react';
import { motion } from 'framer-motion';

function PrivacyControls({
    privateDescription,
    publicDescription,
    selectPublic,
    selectPrivate,
    isPublic
}) {
    return (
        <div
        style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            width: '100%',
            maxWidth: '500px',
            margin: '0 auto',
        }}
    >
        <p
            className="selection-hint"
            style={{ color: 'rgb(156, 163, 175)', margin: '1rem 0rem', textAlign: 'center' }}
        >
            Visibility Preferences:
        </p>

        <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
            <div
                onClick={selectPublic}
                style={{
                    cursor: 'pointer',
                    transition: 'all 0.2s ease-in-out',
                    border: `2px solid ${isPublic ? '#3B82F6' : '#E5E7EB'}`,
                    backgroundColor: isPublic ? '#EFF6FF' : '#FFFFFF',
                    padding: '12px',
                    borderRadius: '16px',
                    boxShadow:
                        isPublic
                            ? '0 2px 6px rgba(0,0,0,0.1)'
                            : '0 1px 3px rgba(0,0,0,0.05)',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: '12px',
                    }}
                >
                    <div>
                        <Globe
                            style={{
                                width: '24px',
                                height: '24px',
                                color: isPublic ? '#2563EB' : '#6B7280',
                                marginTop: '4px',
                            }}
                        />
                    </div>
                    <div style={{ width: "100%", paddingRight: "32px" }}>
                        <h3
                            style={{
                                fontWeight: '600',
                                fontSize: '18px',
                                margin: 0,
                            }}
                        >Public</h3>
                        <p
                            style={{
                                fontSize: '14px',
                                color: '#4B5563',
                                marginTop: '4px',
                            }}
                        >
                            {publicDescription}
                        </p>
                    </div>
                </div>
            </div>
        </motion.div>

        <motion.div whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
            <div
                onClick={selectPrivate}
                style={{
                    cursor: 'pointer',
                    transition: 'all 0.2s ease-in-out',
                    border: `2px solid ${!isPublic ? '#3B82F6' : '#E5E7EB'}`,
                    backgroundColor: !isPublic ? '#EFF6FF' : '#FFFFFF',
                    padding: '12px',
                    borderRadius: '16px',
                    boxShadow:
                        !isPublic
                            ? '0 2px 6px rgba(0,0,0,0.1)'
                            : '0 1px 3px rgba(0,0,0,0.05)',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: '12px',
                    }}
                >
                    <div>
                        <Lock
                            style={{
                                width: '24px',
                                height: '24px',
                                color: !isPublic ? '#2563EB' : '#6B7280',
                                marginTop: '4px',
                            }}
                        />
                    </div>
                    <div style={{ width: "100%", paddingRight: "32px" }}>
                        <h3
                            style={{
                                fontWeight: '600',
                                fontSize: '18px',
                                margin: 0,
                            }}
                        >
                            Private
                        </h3>
                        <p
                            style={{
                                fontSize: '14px',
                                color: '#4B5563',
                                marginTop: '4px',
                            }}
                        >
                            {privateDescription}
                        </p>
                    </div>
                </div>
            </div>
        </motion.div>
    </div>
    )
}

export default PrivacyControls